<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
        <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
        >
          <slot></slot>
        </span>

      </template>
      <span>{{this.$props.title}}}</span>
        </v-tooltip>
</template>

<script>
    export default {
        props: ["title"],
        name: "TooltipTop"
    }
</script>

<style scoped>

</style>